import { Box, Typography, makeStyles } from "@material-ui/core";

import Phone from "../../../components/Phone";
import AvatarforMemberPanel from "../../../components/AvatarforMemberPanel";
import { useTranslate } from "react-admin";
const useStyles = makeStyles((theme) => ({
  avatarBorder: {
    marginTop: 20,
    justifyContent: "center",
    display: "flex",
    width: "121px",
    height: "121px",
    alignItem: "center",
    backgroundColor: theme.blue,
  },
  editIcon: {
    height: 27,
    width: 27,
  },
  avatar: {
    width: "121px",
    height: "121px",
    fontSize: 50,
    color: theme.blue,
    borderWidth: 10,
    backgroundColor: "white",
  },
  rightSideProfileContainer: {
    width: "30%",
    backgroundColor: theme.pureWhite,
    paddingTop: 40,
    boxSizing: "border-box",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  name: {
    fontSize: 24,
    fontWeight: "bolder",
    marginTop: 20,
  },
  sideProfileTextContact: {},
  sideProfileTextBold: {},
  rightSideProfileContainerEmail: {
    width: 280,
    height: 70,
    display: "flex",
    margin: "10px 20px",
    borderRadius: "8px",
    backgroundColor: theme.lightGray,
    alignItems: "center",
  },
  rightSideProfileContainerReferal: {
    width: 280,
    height: 70,
    display: "block",
    justifyContent: "center",
    margin: "10px 20px",
    borderRadius: "8px",
    backgroundColor: theme.lightGray,
  },
  rightSideProfileContainerGenderAndStatus: {
    display: "block",
    justifyContent: "center",
    margin: "10px 20px",
    borderRadius: "8px",
    backgroundColor: theme.lightGray,
    width: 280,
    height: 70,
  },
  flexAndSpaceBetween: {
    display: "flex",
    justifyContent: "space-between",
  },
  emailTextMargin: { marginLeft: "30px" },
  referredHeaderTextStyle: { margin: "20px auto 0px", fontSize: 16 },
  recommendType: { fontSize: 20, fontWeight: "bold" },
  genderAndAgeTextStyle: {
    flex: "1",
    margin: "5px 10px",
    fontSize: 20,
    fontWeight: "bold",
    marginLeft: 30,
  },
  ageValueTextStyle: {
    flex: "1",
    margin: "5px 10px",
    fontSize: 20,
    fontWeight: "bold",
  },
  ageTextStyle: {
    flex: "1",
    margin: "5px 10px",
    fontSize: 16,
  },
  topTextStyle: { 
    flex: "1", 
    margin: "5px 10px", 
    fontSize: 16, 
    marginLeft: 30 
  },
  textStyleFollowed: {
    flex: "1",
    margin: "5px 10px",
    fontSize: 20,
    fontWeight: "bold",
    color: theme.green,
  },
  leadTextStyle: {
    flex: "1",
    margin: "5px 0px",
    fontSize: 20,
    fontWeight: "bold",
  },
  TextUserProfileData: { marginRight: 10 },
}));
function ProfileSideInformation({ userProfileData }) {
  const classes = useStyles();
  const translate = useTranslate();
  return (
    <Box className={classes.rightSideProfileContainer}>
      <Box display="flex" justifyContent="center">
        <AvatarforMemberPanel
          alt={userProfileData.firstName}
          src={userProfileData.imageUrl}
          memberId={userProfileData.id}
          version={userProfileData.version}
          isPotential={true}
        />
        {
          // <input
          //   accept="image/*"
          //   id="contained-button-file"
          //   type="file"
          //   style={{ display: "none" }}
          //   // onChange={(e) => onChangeSelectImageHandler(e.target.files[0])}
          // />
          // <label htmlFor="contained-button-file">
          //   <Badge
          //     overlap="circle"
          //     anchorOrigin={{
          //       vertical: "bottom",
          //       horizontal: "right",
          //     }}
          //     badgeContent={
          //       <Avatar
          //         alt="edit"
          //         src={EditIcons}
          //         className={classes.editIcon}
          //       />
          //     }
          //   >
          //     <Avatar
          //       alt="?"
          //       src={userProfileData.imageUrl ?? userProfileData.firstname}
          //       className={classes.avatar}
          //       firstNameEn
          //     />
          //   </Badge>
          // </label>
        }
      </Box>
      <Typography align="center" className={classes.name}>
        {`${userProfileData.firstName} ${userProfileData.lastName}`}
      </Typography>
      <Phone number={userProfileData.phoneNumber} />

      <Box className={classes.rightSideProfileContainerEmail}>
        <Typography align="center" className={classes.emailTextMargin}>
          {`${translate("ra.text.ci.generalInformation.email")}  `}
        </Typography>
        <Typography align="center" className={classes.emailTextMargin}>{`${
          userProfileData.email ?? "-"
        }`}</Typography>
      </Box>
      <Box className={classes.rightSideProfileContainerReferal}>
        <Box className={classes.grayBox_subBox}>
          <Typography
            align="center"
            className={classes.referredHeaderTextStyle}
          >
            Referred by
          </Typography>
          <Typography className={classes.bold} align="center">
            {"-"}
          </Typography>
        </Box>
      </Box>
      <Box className={classes.rightSideProfileContainerGenderAndStatus}>
        <Box className={classes.flexAndSpaceBetween}>
          <Typography className={classes.topTextStyle}>
            {translate("ra.text.ci.generalInformation.gender")}
          </Typography>
          <Typography className={classes.ageTextStyle}>
            {translate("ra.text.ci.generalInformation.age")}
          </Typography>
        </Box>
        <Box className={classes.flexAndSpaceBetween}>
          <Typography className={classes.genderAndAgeTextStyle}>
            {userProfileData.gender}
          </Typography>
          <Typography className={classes.ageValueTextStyle}>
          {userProfileData.age ? userProfileData.age : "-" }
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}

export default ProfileSideInformation;
